import moment from 'moment';
import {getCookie} from "../../../../helper/cookie";

export let always = function () {
    return true
}

export let never = function () {
    return false
}

export let and = function (...otherConditions) {
    return function (parametersObj) {
        for (let i = 0; i < otherConditions.length; i++) {
            if (!otherConditions[i](parametersObj))
                return false
        }

        return true
    }
}

export let or = function (...otherConditions) {
    return function (parametersObj) {
        for (let i = 0; i < otherConditions.length; i++) {
            if (otherConditions[i](parametersObj))
                return true
        }

        return false
    }
}

export let not = function (otherCondition) {
    return function (parametersObj) {
        return !otherCondition(parametersObj)
    }
}

export let questionIs = function (questionKey, value, useV1EDCQuestionFn = null) {
    return function (parametersObj) {
        if (useV1EDCQuestionFn && useV1EDCQuestionFn(parametersObj)){
            return parametersObj.state[questionKey + '_V1'] === value
        }else{
            return parametersObj.state[questionKey] === value
        }
    }
}

export let questionIsYes = function (questionKey, useV1EDCQuestionFn = null) {
    return function (parametersObj) {
        if (useV1EDCQuestionFn && useV1EDCQuestionFn(parametersObj)){
            return parametersObj.state[questionKey + '_V1'] === "YES"
        }else{
            return parametersObj.state[questionKey] === "YES"
        }
    }
}

export let questionIsNo = function (questionKey, useV1EDCQuestionFn = null) {
    return function (parametersObj) {
        if (useV1EDCQuestionFn && useV1EDCQuestionFn(parametersObj)){
            return parametersObj.state[questionKey + '_V1'] === "NO"
        }else{
            return parametersObj.state[questionKey] === "NO"
        }
    }
}

export let questionIsYesOrNo = function (questionKey) {
    return function ({state}) {
        return state[questionKey] === "YES" || state[questionKey] === "NO"
    }
}

export let visitNumberIs = function (...visitNumbers) {
    return function ({visit, config}) {
        return visitNumbers.includes(parseInt(visit))
    }
}

export let givenVisitIsStatus = function (visitNumber, status) {
    return function ({rootGetters}) {
        const encounter = rootGetters['patientSummary/getEncounter'](visitNumber);

        if (encounter){
            return encounter.status === status
        }else{
            return false
        }
    }
}

const onNewDiagnosisSinceLastVisitOrVisit67Condition = or(
    questionIsYes('NEW_DIAGNOSIS'),
    visitNumberIs(6, 7)
);

export let onNewDiagnosisSinceLastVisitOrVisit67 = function (parametersObject) {
    return onNewDiagnosisSinceLastVisitOrVisit67Condition(parametersObject)
}

const visit2OrVisit6And2SkippedCondition = or(
    visitNumberIs(2),
    and(
        visitNumberIs(6),
        givenVisitIsStatus(2, 'skipped')
    )
);

export let v2QuestionNotEntered = function (questionKey) {
    return function (parametersObj) {
        return !parametersObj?.state[questionKey + '_V2']
    }
}

export let currentVisitQuestionEntered = function (questionKey) {
    return function (parametersObj) {
        return !!parametersObj?.state[questionKey]
    }
}


export let visit2OrVisit6AndQuestionNotEnteredInVisit2 = function (questionKey) {
    return or(
        visitNumberIs(2),
        and(
            visitNumberIs(6),
            or (
                v2QuestionNotEntered(questionKey),
                // If it was entered in the current visit, keep the answer. This is to prevent the case that if the
                // case nurse goes back to visit2 and still decides to answer there. Any answer that was already provided
                // in v6 will remain visible there.
                currentVisitQuestionEntered(questionKey),
            ),
        )
    );
}

export let visit2OrVisit6And2Skipped = function (parametersObject) {
    return visit2OrVisit6And2SkippedCondition(parametersObject)
}

export let hadPCIAfter = function (dateMoment, useV1EDCQuestionFn = null) {
    return function (parametersObject) {
        if (useV1EDCQuestionFn && useV1EDCQuestionFn(parametersObject)){
            if (parametersObject.state.HAD_PCI_V1 === "YES" && parametersObject.state.PCI_DATE_V1) {
                return moment(parametersObject.state.PCI_DATE_V1).isSameOrAfter(dateMoment);
            }
        }else{
            if (parametersObject.state.HAD_PCI === "YES" && parametersObject.state.PCI_DATE) {
                return moment(parametersObject.state.PCI_DATE).isSameOrAfter(dateMoment);
            }
        }

        return false
    }
}

export let CHA2DS2VASCGenderIndependentLessThan = function (lessThanValue) {
    return function ({getters}) {
        return getters.CHA2DS2VASCGenderIndependent < lessThanValue
    }
}

export let CHA2DS2VASCGenderIndependentGreaterThan = function (greaterThanValue) {
    return function ({getters}) {
        return getters.CHA2DS2VASCGenderIndependent > greaterThanValue
    }
}

export let numberOfAntiHypertensiveDrugsIncludes = function (...numbers) {
    return function ({getters}) {
        return numbers.includes(getters.numberOfAntiHypertensiveDrugs)
    }
}

export let meanBloodPressureAboveGoal = function ({getters}) {
    return getters.meanBloodPressureAboveGoal
}


// self-contained debug code, can be commented for production
// Example cookie:   name: debugFields     ->  value:   ["INTOLERANCE_ASPIRIN"]
// Refresh browser after putting cookie
const debugFieldsCookie = getCookie('debugFields')
const fieldsToDebug = debugFieldsCookie ? JSON.parse(debugFieldsCookie) : [];

if (fieldsToDebug && fieldsToDebug.length) {
    console.log("Field condition debugging enabled")
    console.log(fieldsToDebug)

    // Conditionals
    onNewDiagnosisSinceLastVisitOrVisit67 = debugMonkeyPatchConditional(onNewDiagnosisSinceLastVisitOrVisit67)
    meanBloodPressureAboveGoal = debugMonkeyPatchConditional(meanBloodPressureAboveGoal)

    // Conditional Generators
    questionIs = debugMonkeyPatchConditionalGenerator(questionIs)
    questionIsYes = debugMonkeyPatchConditionalGenerator(questionIsYes)
    questionIsNo = debugMonkeyPatchConditionalGenerator(questionIsNo)
    questionIsYesOrNo = debugMonkeyPatchConditionalGenerator(questionIsYesOrNo)
    visitNumberIs = debugMonkeyPatchConditionalGenerator(visitNumberIs)
    givenVisitIsStatus = debugMonkeyPatchConditionalGenerator(givenVisitIsStatus)
    hadPCIAfter = debugMonkeyPatchConditionalGenerator(hadPCIAfter)
    and = debugMonkeyPatchConditionalGenerator(and)
    or = debugMonkeyPatchConditionalGenerator(or)
    not = debugMonkeyPatchConditionalGenerator(not)
    CHA2DS2VASCGenderIndependentLessThan = debugMonkeyPatchConditionalGenerator(CHA2DS2VASCGenderIndependentLessThan)
    CHA2DS2VASCGenderIndependentGreaterThan = debugMonkeyPatchConditionalGenerator(CHA2DS2VASCGenderIndependentGreaterThan)
    numberOfAntiHypertensiveDrugsIncludes = debugMonkeyPatchConditionalGenerator(numberOfAntiHypertensiveDrugsIncludes)
    visit2OrVisit6AndQuestionNotEnteredInVisit2 = debugMonkeyPatchConditionalGenerator(visit2OrVisit6AndQuestionNotEnteredInVisit2)
    v2QuestionNotEntered = debugMonkeyPatchConditionalGenerator(v2QuestionNotEntered)
    currentVisitQuestionEntered = debugMonkeyPatchConditionalGenerator(currentVisitQuestionEntered)
}

function debugMonkeyPatchConditional(conditional) {
    const fn = function (parametersObj) {
        const result = conditional(parametersObj)
        const resultString = JSON.stringify(result)

        if (fieldsToDebug.includes(parametersObj.config.key))
            console.log(`Executing check ${fn.__patchedName ? `<${fn.__uniq}>${fn.__patchedName}${debugParametersToArgumentList(fn.__parameters, parametersObj)} -> ${resultString}` : `${fn.name} -> ${resultString}`} on ${parametersObj.config.key}`)

        return result
    }

    fn.__conditional = conditional;
    fn.__patchedName = conditional.name
    fn.__uniq = debugNumber()

    return fn;
}

function debugMonkeyPatchConditionalGenerator(conditionalGenerator) {
    return function (...parameters) {
        const fn = debugMonkeyPatchConditional(conditionalGenerator(...parameters))

        fn.__patchedName = conditionalGenerator.name
        fn.__uniq = debugNumber()
        fn.__parameters = parameters;

        return fn;
    }
}

function debugParametersToArgumentList(parameters, parametersObj) {
    if (!parameters) return '()'

    const p = [];

    for (let i = 0; i < parameters.length; i++) {
        const parameter = parameters[i]

        if (isPrimitive(parameter)) {
            p.push(parameter)
        } else if (typeof parameter === "function") {
            if (parameter.__conditional) {
                const result = parameter.__conditional(parametersObj);
                p.push(`<${parameter.__uniq}>${parameter.__patchedName} -> ${JSON.stringify(result)}`);
            } else {
                p.push(parameter.name);
            }
        } else if (Array.isArray(parameter)) {
            p.push(debugParametersToArgumentList(parameter))
        } else {
            p.push(JSON.stringify(parameter))
        }
    }

    return '(' + p.join(', ') + ')'
}

let dNumber = 0;

function debugNumber() {
    return dNumber++
}

function isPrimitive(arg) {
    const type = typeof arg;
    return arg == null || (type !== "object" && type !== "function");
}


